import { ComponentLoader } from '@bythepixel/component-loader';
import DealerLocatorForm from '../components/dealerLocatorForm';
import initDealerLocator from '../dealerLocator';

window.springSaleComponents = new ComponentLoader(document, [
  DealerLocatorForm,
], () => {
  initDealerLocator();
});
